export const ADD_PATIENT_REQUEST = "PATIENT/ADD_PATIENT_REQUEST";
export const ADD_PATIENT_SUCCESS = "PATIENT/ADD_PATIENT_SUCCESS";
export const ADD_PATIENT_FAILURE = "PATIENT/ADD_PATIENT_FAILURE";

export const GET_PATIENT_LIST_REQUEST = "PATIENT/GET_PATIENT_LIST_REQUEST";
export const GET_PATIENT_LIST_SUCCESS = "PATIENT/GET_PATIENT_LIST_SUCCESS";
export const GET_PATIENT_LIST_FAILURE = "PATIENT/GET_PATIENT_LIST_FAILURE";

export const DELETE_PATIENT_REQUEST = "PATIENT/DELETE_PATIENT_REQUEST";
export const DELETE_PATIENT_SUCCESS = "PATIENT/DELETE_PATIENT_SUCCESS";
export const DELETE_PATIENT_FAILURE = "PATIENT/DELETE_PATIENT_FAILURE";

export const EDIT_PATIENT_REQUEST = "PATIENT/EDIT_PATIENT_REQUEST";
export const EDIT_PATIENT_SUCCESS = "PATIENT/EDIT_PATIENT_SUCCESS";
export const EDIT_PATIENT_FAILURE = "PATIENT/EDIT_PATIENT_FAILURE";

export const ADD_BOOKING_REQUEST = "BOOKING/ADD_BOOKING_REQUEST";
export const ADD_BOOKING_SUCCESS = "BOOKING/ADD_BOOKING_SUCCESS";
export const ADD_BOOKING_FAILURE = "BOOKING/ADD_BOOKING_FAILURE";

export const UPDATE_GUIDE_REQUEST = "USER/UPDATE_GUIDE_REQUEST";
export const UPDATE_GUIDE_SUCCESS = "USER/UPDATE_GUIDE_SUCCESS";
export const UPDATE_GUIDE_FAILURE = "USER/UPDATE_GUIDE_FAILURE";

export const GET_CASE_DETAILS_REQUEST = "HOME_CASE_DETAILS/GET_CASE_DETAILS_REQUEST";
export const GET_CASE_DETAILS_SUCCESS = "HOME_CASE_DETAILS/GET_CASE_DETAILS_SUCCESS";
export const GET_CASE_DETAILS_FAILURE = "HOME_CASE_DETAILS/GET_CASE_DETAILS_FAILURE";

export const ADD_PICKUP_REQUEST = "CASE_DETAILS/ADD_PICKUP_REQUEST";
export const ADD_PICKUP_SUCCESS = "CASE_DETAILS/ADD_PICKUP_SUCCESS";
export const ADD_PICKUP_FAILURE = "CASE_DETAILS/ADD_PICKUP_FAILURE";

export const GET_PARENT_CASES = "CASES/GET_PARENT_CASES";
export const GET_PARENT_CASES_SUCCESS = "CASES/GET_PARENT_CASES_SUCCESS";
export const GET_PARENT_CASES_FAILURE = "CASES/GET_PARENT_CASES_FAILURE";
export const GET_CASES_FILTERS_DENTIST = "GET_CASES_FILTERS_DENTIST";
export const SET_FILTER_VALUES_DENTIST = "SET_FILTER_VALUES_DENTIST";


// WEBPACK FOOTER //
// ./src/containers/Layouts/User/Home/constants.js